export const MENU_CONTENT_TYPES = {
  INTERACTIVE: "interactive",
  STATIC: "static",
};

export function normalizeMenuContentType(value) {
  return value === MENU_CONTENT_TYPES.STATIC
    ? MENU_CONTENT_TYPES.STATIC
    : MENU_CONTENT_TYPES.INTERACTIVE;
}
